<template>
  <div class="py-1">
    <template
      v-for="(group, groupIndex) in groups"
      :key="group.key">
      <MenuDivider v-if="groupIndex > 0" />
      <MenuOption
        v-for="item in group.items"
        :id="item.id"
        :key="item.id"
        :title="item.label"
        :class="item.tone === 'danger' ? 'text-feedback-error' : ''"
        :isDisabled="item.isDisabled"
        @select="onSelect(item)">
        <template #icon>
          <div class="flex items-center gap-1.5">
            <DevBadge v-if="item.tone === 'dev'" />
            <component
              :is="item.icon"
              class="h-4 w-4" />
          </div>
        </template>
      </MenuOption>
    </template>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { IInvoiceMenuItem } from '@/globals/typescript/utils/invoiceMenuItems'

/**
 * The ⋮ menu of the Fakturering card — and of each side of a split order. It renders the items
 * it is given and nothing else: which items a state offers is decided by
 * `getOrderInvoiceCardState`, so an action is never both a visible button and a menu item.
 * Ordinary items first, then the destructive ones, then the DEV reset, each group behind a divider.
 */
export default {
  name: 'PaymentStatusMenu',

  emits: ['close'],

  props: {
    items: { type: Array as PropType<IInvoiceMenuItem[]>, required: true },
  },

  computed: {
    groups(): { key: string; items: IInvoiceMenuItem[] }[] {
      return [
        { key: 'default', items: this.items.filter((x) => !x.tone) },
        { key: 'danger', items: this.items.filter((x) => x.tone === 'danger') },
        { key: 'dev', items: this.items.filter((x) => x.tone === 'dev') },
      ].filter((x) => x.items.length > 0)
    },
  },

  methods: {
    onSelect(item: IInvoiceMenuItem): void {
      this.$emit('close')
      void item.onSelect()
    },
  },
}
</script>
